module.exports = __webpack_public_path__ + "img/mobile.002b8e6a.svg";